import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { InstallCard } from "@/components/InstallCard";
import { useInstall } from "@/lib/pwa";

const KEY = "rollsmartr_install_prompt_at";
const SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;
const snoozed = () => Date.now() - Number(localStorage.getItem(KEY) || 0) < SNOOZE_MS;

export function InstallPrompt() {
  const { user } = useAuth();
  const { installed } = useInstall();
  const [open, setOpen] = useState(false);
  const eligible = !!user && user.onboarded !== false && !installed && !snoozed();

  useEffect(() => {
    if (!eligible) return;
    const t = setTimeout(() => {
      localStorage.setItem(KEY, String(Date.now()));
      setOpen(true);
    }, 2500);
    return () => clearTimeout(t);
  }, [eligible]);

  useEffect(() => {
    if (installed) setOpen(false);
  }, [installed]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="bg-[#161618] border-[#27272A] max-w-[88vw] sm:max-w-sm rounded-3xl p-6" data-testid="install-prompt" onOpenAutoFocus={(e) => e.preventDefault()}>
        <img src="/icon-192.png" alt="Roll SmartR icon" className="mx-auto w-14 h-14 rounded-2xl mb-1" />
        <DialogTitle className="font-display text-2xl uppercase tracking-tight text-center">Install Roll SmartR</DialogTitle>
        <DialogDescription className="text-[#A1A1AA] text-sm text-center">Opens full-screen like a real app, works offline and lets you get training reminders.</DialogDescription>
        <div className="mt-2"><InstallCard compact /></div>
        <button data-testid="install-prompt-dismiss" onClick={() => setOpen(false)} className="w-full h-10 text-sm text-[#A1A1AA] hover:text-white transition-colors">Not now</button>
      </DialogContent>
    </Dialog>
  );
}
